import makeStyles, { modal } from './style';
import { useTranslation } from 'react-i18next';
import Modal from '@mui/material/Modal';

import Triangle from '../../assets/images/triangle.png';
import { useDispatch, useSelector } from 'react-redux';
import { triggerModal } from '../../redux/actions/appState';

const TransactionFailed = (props) => {
  const classes = makeStyles(props);
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const { open, message } = useSelector((state) => ({
    open: state?.appState?.failedTransactionModal,
    message: state?.appState?.failedTransactionModalMessage,
  }));

  return (
    <Modal open={open} sx={modal}>
      <div className={classes.modalBody}>
        <div className={classes.container}>
          <img src={Triangle} className={classes.triangle} />
          <h3 className={classes.title}>{t('transactionFailedTitle')}</h3>
          <div className={classes.errorMessageContainer}>
            <p className={classes.text}>{message}</p>
          </div>
          <button
            className={classes.button}
            onClick={() => dispatch(triggerModal(false, ''))}
          >
            <h5 className={classes.buttonText}>
              {t('transactionFailedAction')}
            </h5>
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default TransactionFailed;
